import { Stack, Card, CardContent, Typography, Divider } from "@mui/material";
import { useTranslation } from 'react-i18next';



export default function MonitoringBanner(props) {

    const {data} = props;

    const { t } = useTranslation();

    const total = (data.data?.length > 0) ? 
            data.data.map(
                (trend) => trend.values.reduce((acc, val) => acc + val, 0.0)
            ).reduce((acc, val) => acc + val, 0.0)
    : undefined;


    return (
        <Stack direction="row" spacing={2} sx={{
            overflow: 'auto',          
            whiteSpace: 'nowrap',
            width: '100%',
            pb: 2
          }}>
            <Card>
                <CardContent>
                    <Typography sx={{ color: 'text.secondary', fontSize: 14 }}>
                        {"Total"}
                    </Typography>
                    <Typography variant="h5">
                        {
                        total? total.toLocaleString(undefined, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        }) + " kWh" : ""
                    }
                    </Typography>
                </CardContent>
            </Card>
            <Divider orientation="vertical" flexItem />
            {
                data.data?.map((trend)=>
                    <Card key={trend.metadata.location ?? trend.metadata.system} sx={{ flexShrink: 0 }}>
                        <CardContent>
                            <Typography sx={{ color: 'text.secondary', fontSize: 14 }}>
                                {trend.metadata.location ?? trend.metadata.system}
                            </Typography>
                            <Typography variant="h5">
                            {trend.values.reduce((acc, val) => acc + val, 0.0).toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            }) + " kWh"}
                            </Typography>
                        </CardContent>
                    </Card>
                )
            }
        </Stack>
    )

};